import axios from 'axios';
import {
  ON_BOARDING_GET_GOOGLE_FONTS_BEGIN,
  ON_BOARDING_GET_GOOGLE_FONTS_SUCCESS,
  ON_BOARDING_GET_GOOGLE_FONTS_FAILURE,
  ON_BOARDING_GET_GOOGLE_FONTS_DISMISS_ERROR,
} from './constants';

export function getGoogleFonts(args = {}) {
  return (dispatch) => {
    dispatch({
      type: ON_BOARDING_GET_GOOGLE_FONTS_BEGIN,
    });
    const url = `https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyA_lEdY21gDOmr0tv4cZOX_BCjazf_P3R8`;
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(url);
      doRequest.then(
        (res) => {
          dispatch({
            type: ON_BOARDING_GET_GOOGLE_FONTS_SUCCESS,
            data: res.data.items,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: ON_BOARDING_GET_GOOGLE_FONTS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetGoogleFontsError() {
  return {
    type: ON_BOARDING_GET_GOOGLE_FONTS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case ON_BOARDING_GET_GOOGLE_FONTS_BEGIN:
      return {
        ...state,
        getGoogleFontsPending: true,
        getGoogleFontsError: null,
      };

    case ON_BOARDING_GET_GOOGLE_FONTS_SUCCESS:
      // The request is success
      return {
        ...state,
        getGoogleFontsPending: false,
        getGoogleFontsError: null,
        googleFonts: action.data,
      };

    case ON_BOARDING_GET_GOOGLE_FONTS_FAILURE:
      // The request is failed
      return {
        ...state,
        getGoogleFontsPending: false,
        getGoogleFontsError: action.data.error,
      };

    case ON_BOARDING_GET_GOOGLE_FONTS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getGoogleFontsError: null,
      };

    default:
      return state;
  }
}
